<template>
    <ReaderModal
        :header-absolute="true"
        :aria-label="localizations[lang].promoteApp.title_read || 'Download app'"
        @close-modal="closePromoteApp"
    >
        <ReaderPromoteApp />
    </ReaderModal>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import ReaderModal from '../ReaderModal/ReaderModal.vue';
import ReaderPromoteApp from './ReaderPromoteApp.vue';

export default {
    components: {
        ReaderModal,
        ReaderPromoteApp,
    },
    computed: {
        ...mapState(['localizations', 'lang']),
    },
    methods: {
        ...mapMutations(['closePromoteApp']),
    },
};
</script>
